import { AuthFormActionsTypes } from '../../../enums/ActionEnums';
export const authFormActions = {
    updateStep: (payload) => ({
        type: AuthFormActionsTypes.UPDATE_STEP_TYPE,
        payload,
    }),
};
